import { createContext } from "react"

export const userContext = createContext({
    userInfo: {
        userId: 0,
        userName: '',
        node: '',
        userRole: 0,
    },
    setUser: (userInfo) => {}
})